
import { useEffect } from 'react';

const FrameBuster = () => {

  useEffect(() => {

    const isTopLevel = window.self === window.top;




    if (!isTopLevel) {

      window.top.location.href = window.self.location.href;

    }

  }, []);
  return null;
};
export default FrameBuster;